// extracted by mini-css-extract-plugin
export default {"journalModalContainer":"Journal_journalModalContainer__rt-TH"};